import { getPath } from '@/router/common'

const baseUrl = {
  title: '业务支出请款',
  path: 'PleaseInquire'
}

export default [
  {
    path: getPath('PleaseInquireWriteoff', baseUrl),
    name: 'PleaseInquire_PleaseInquireWriteoff',
    component: () =>
      import(
        /* webpackChunkName: "PleaseInquire_PleaseInquireWriteoff" */ '@/views/pleaseInquire/pleaseInquireWriteoff/index.vue'
      ),
    meta: {
      title: '业务支出请款'
    }
  },
  {
    path: getPath('PleaseReview', baseUrl),
    name: 'PleaseInquire_PleaseReview',
    component: () => import(/* webpackChunkName: "PleaseInquire_PleaseReview" */ '@/views/pleaseInquire/pleaseReview/index.vue'),
    meta: {
      title: '请款审批'
    }
  },
  {
    path: getPath('PleaseInquire_Index', baseUrl),
    name: 'PleaseInquire_PleaseInquire_Index',
    component: () => import(/* webpackChunkName: "PleaseInquire_PleaseInquire_Index" */ '@/views/pleaseInquire/pleaseInquire_Index/index.vue'),
    meta: {
      title: '请款结果'
    }
  },
  {
    path: getPath('GeneratingJournal', baseUrl),
    name: 'PleaseInquire_GeneratingJournal',
    component: () => import(/* webpackChunkName: "PleaseInquire_GeneratingJournal" */ '@/views/pleaseInquire/generatingJournal/index.vue'),
    meta: {
      title: '请款单生成日记账'
    }
  },
  {
    path: getPath('DinDinInfo', baseUrl),
    name: 'PleaseInquire_DinDinInfo',
    component: () => import(/* webpackChunkName: "PleaseInquire_DinDinInfo" */ '@/views/pleaseInquire/dinDinInfo/index.vue'),
    meta: {
      title: '钉钉推送记录'
    }
  }
]
